// extracted by mini-css-extract-plugin
export default {"form":"add-purchase-modal_form__f83PS","field":"add-purchase-modal_field__8hWw5"};